import { DatePicker as DatePickerAntd } from 'antd';
import styled from 'styled-components';

import { COLOR } from 'styles/styledComponents/color.model';

export const DatePicker = styled(DatePickerAntd)`
  width: 100%;
  padding: 0 11px;
`;

export const InvalidFormatMessage = styled.div`
  opacity: 1;
  position: absolute;
  bottom: -22px;
  font-size: 12px;
  color: ${COLOR.BLOOD_BURST};
`;
